/* eslint-disable */
import React, {useEffect, useState} from 'react'
import ButtonV2 from 'components/ButtonV2';
import Modal from 'react-modal';
import styled from 'styled-components';
const Icon = styled.img``;
import Svg from "_assets/svg";
import FeatherIcon from 'feather-icons-react';
import {useHistory} from 'react-router-dom';
import { listLanguage} from 'containers/NewWaTemplate/ListDropdownData';

// style
import './ConfirmModalSubmit.scss'

const customStyles = {
  content: {
    top: '50%',
    left: '50%',
    right: 'auto',
    bottom: 'auto',
    // marginRight: '-50%',
    transform: 'translate(-50%, -50%)',
    background: '#FFFFFF',
    border: '1px solid #EBECF0',
    boxShadow: '1px 1px 20px rgba(170, 170, 170, 0.2)',
    borderRadius: '10px',
    width: '600px',
    padding: '20px'
  },
};

function SuccessSubmitTemplate(props) {
  const {openSuccessSubmitModal, setOpenSuccessSubmitModal} = props;
  const [isDataSummary, setDataSummary] = useState([])
  const history = useHistory();
  
  useEffect(()=>{
    if(openSuccessSubmitModal?.payload){
      listLanguage.forEach((langData) => {
        openSuccessSubmitModal?.payload.forEach((item) =>{
          if(langData.value === item.language){
            item.dataLanguage = langData.name;
          }
        })
      })
    }
    setDataSummary(openSuccessSubmitModal.payload)
  }, [openSuccessSubmitModal.payload])

  function closeModal() {
    history.push('/whatsapp-template')
    setOpenSuccessSubmitModal({show:false, payload: []})
  }


  return (
    <Modal
    isOpen={openSuccessSubmitModal.show}
    onRequestClose={closeModal}
    style={customStyles}
    contentLabel="Example Modal"
  >
  <div className='d-flex align-items-center justify-content-between pb-3'>
    <h3 className='fsize-20 cl-neutral500 fweight-600 mb-0'>Message Template Submitted</h3>
    <div className="cursor-pointer" onClick={closeModal}>
      <FeatherIcon icon="x" />
    </div>
  </div>
    <div className='mb-4 d-flex align-items-baseline'>
      <Icon src={Svg.check_success.default} alt="check_success" className='me-2' />
      <p className='fsize-14 fweight-600 cl-neutral400 mb-0'>{isDataSummary?.length} content changes were made. Any new or edited content will automatically be submitted for review.</p>
    </div>
    <div className="wrapperr_body">
      {isDataSummary && isDataSummary.map((item, index) => {
        return (
        <div key={index}>
          <div className='fsize-14 fweight-400 cl-grey d-flex align-items-center title_border_submit pb-2 mb-3 mx-3'>
            <span>You <strong>{item.dataLanguage}</strong>  content was added.</span>
          </div>
        </div>
        )})}
      <div className='d-flex align-items-center justify-content-end pt-5 mt-5'>
        <ButtonV2
          className="ms-4"
          handleRoute={closeModal}
          disabled
          backgroundColor="#3B3B47"
          textColor="#FFFFFF"
          padding=".360rem 1rem"
        >
          Done
        </ButtonV2>
      </div>
    </div>      
  </Modal>
  )
}

export default SuccessSubmitTemplate